import { Link } from "react-router-dom";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { Reveal } from "../Reveal";
import { useContents } from "../../hooks/useContents";
import { imgUrl } from "../../lib/api";

const POINTS = [
  "Attenzione ai dettagli in ogni lavorazione",
  "Cantieri ordinati e organizzati",
  "Rispetto delle tempistiche concordate",
  "Rapporto diretto e trasparente con il cliente",
];

export const ChiSiamo = () => {
  const c = useContents();
  return (
  <section id="chi-siamo" data-testid="chi-siamo-section" className="py-20 lg:py-32">
    <div className="max-w-7xl mx-auto px-5 lg:px-10 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
      <Reveal className="order-2 lg:order-1">
        <div className="steel-frame">
          <div className="aspect-[4/5] overflow-hidden border border-steel">
            <img
              src={imgUrl(c("about_img", "/images/about.jpg"))}
              alt="Muratore al lavoro su una parete in costruzione"
              loading="lazy"
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-[1.2s]"
            />
          </div>
        </div>
      </Reveal>
      <div className="order-1 lg:order-2">
        <SectionHeading
          number="01"
          overline="Chi siamo"
          lines={["Costruire è il nostro mestiere.", "Farlo bene è la nostra priorità."]}
        />
        <Reveal delay={0.2}>
          <div className="mt-7 space-y-4 text-cement leading-relaxed text-[15px] sm:text-base">
            <p>{c("about_p1", "Costruzioni Ciosko nasce dalla passione per il lavoro e dalla volontà di offrire ai nostri clienti un servizio concreto, professionale e affidabile.")}</p>
            <p>{c("about_p2", "Da generazioni ci occupiamo di costruire, ristrutturare e dare forma agli spazi in cui le persone vivono e lavorano.")}</p>
            <p>{c("about_p3", "Ogni cantiere viene seguito con attenzione, organizzazione e responsabilità, mettendo al centro la qualità del risultato e la soddisfazione del cliente.")}</p>
          </div>
        </Reveal>
        <Reveal delay={0.3}>
          <ul className="mt-7 grid sm:grid-cols-2 gap-3">
            {POINTS.map((p, i) => (
              <li key={i} className="flex items-start gap-2.5 text-sm text-metal/85">
                <CheckCircle2 size={16} className="text-forest-glow shrink-0 mt-0.5" /> {p}
              </li>
            ))}
          </ul>
        </Reveal>
        <Reveal delay={0.4}>
          <Link to="/azienda" data-testid="chi-siamo-more-button" className="btn-ghost mt-9">
            Scopri l'azienda <ArrowRight size={16} />
          </Link>
        </Reveal>
      </div>
    </div>
  </section>
  );
};
